function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 74.9898,
  cy: 48.2843,
  r: 40,
  transform: "rotate(-15 74.9898 48.2843)",
  fill: "#DEDEDE"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 75.1918,
  cy: 48.6274,
  r: 32,
  transform: "rotate(-15 75.1918 48.6274)",
  fill: "#F4F4F4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72 32C72 30.8954 72.8954 30 74 30C75.1046 30 76 30.8954 76 32V44C76 44.1725 75.9782 44.3398 75.9371 44.4995C77.1673 45.1817 78 46.4936 78 48C78 48.3582 77.9529 48.7055 77.8646 49.0358L87.6569 58.8282C88.438 59.6093 88.438 60.8756 87.6569 61.6566C86.8759 62.4377 85.6096 62.4377 84.8285 61.6566L75.0363 51.8645C74.7058 51.9529 74.3584 52 74 52C71.7909 52 70 50.2091 70 48C70 46.4936 70.8327 45.1817 72.0629 44.4995C72.0218 44.3398 72 44.1725 72 44V32Z",
  fill: "#CBCBCB"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 48,
  r: 22,
  fill: "#FFD500"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  transform: "translate(108 34)",
  fill: "#FFD500"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M129 51.3936C129 52.673 128.519 53.773 127.557 54.6936C126.595 55.5986 125.207 56.1603 123.395 56.3787V57.7973C123.395 58.4615 122.857 59 122.192 59V59C121.528 59 120.99 58.4615 120.99 57.7973V56.4489C119.803 56.3865 118.672 56.1837 117.598 55.8404C117.147 55.6965 116.734 55.5389 116.356 55.3675C115.52 54.9875 115.275 53.9825 115.662 53.1489V53.1489V53.1489C116.005 52.4078 116.943 52.1634 117.685 52.5035C117.933 52.6172 118.193 52.7231 118.464 52.8213C119.282 53.1177 120.124 53.305 120.99 53.383V49.4745C119.851 49.2092 118.889 48.9128 118.103 48.5851C117.317 48.2574 116.66 47.7816 116.131 47.1574C115.601 46.5177 115.337 45.6752 115.337 44.6298C115.337 43.3348 115.818 42.227 116.78 41.3064C117.758 40.3702 119.162 39.8007 120.99 39.5979V38.2027C120.99 37.5385 121.528 37 122.192 37V37C122.857 37 123.395 37.5385 123.395 38.2027V39.5511C124.711 39.6551 125.873 39.9014 126.881 40.2899C127.72 40.613 128.024 41.5886 127.677 42.4181V42.4181V42.4181C127.356 43.1853 126.441 43.4919 125.664 43.1961C124.917 42.9116 124.161 42.7263 123.395 42.6404V46.6191C124.518 46.8688 125.464 47.1574 126.234 47.4851C127.019 47.7972 127.677 48.273 128.206 48.9128C128.735 49.5369 129 50.3638 129 51.3936ZM119.21 44.4426C119.21 44.8326 119.362 45.1525 119.667 45.4021C119.971 45.6518 120.412 45.8624 120.99 46.034V42.7106C120.38 42.8511 119.931 43.0773 119.643 43.3894C119.354 43.6858 119.21 44.0369 119.21 44.4426ZM123.395 53.2894C123.973 53.1645 124.405 52.9617 124.694 52.6809C124.983 52.4 125.127 52.0645 125.127 51.6745C125.127 51.2844 124.975 50.9645 124.67 50.7149C124.381 50.4652 123.956 50.2468 123.395 50.0596V53.2894Z",
  fill: "white"
});

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 96,
    viewBox: "0 0 160 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.16b0360b.svg";
export { ForwardRef as ReactComponent };